import { Ability } from "@casl/ability";
import { useAtomValue } from "jotai";
import { BonusXAbility } from "../interfaces/BonusXAbility";
import { AbilityRulesStore } from "../stores/abilityRulesStore";

export function useAbility(): BonusXAbility {
  const rules = useAtomValue(AbilityRulesStore);
  return new Ability(rules);
}
